<template>
  <div>
    <dig-tab @OnChangeTab="OnChangeTab" class="padding" :items="userItems" :selectedIndex.sync="selectedUserTab">
      <dig-table v-if="selectedUserTab == 0" :items="userList.data" :isLoading="userList.isLoading" :hidden="userList.hidden"></dig-table>
      <div v-if="selectedUserTab == 1">
        <dig-form ref="formAdd" :show-title-item=true :title="'Add'" :items="add.form" :isLoading="add.isLoading" @OnSubmit="OnSubmitAdd"></dig-form>
      </div>
    </dig-tab>
    <dig-notif :text="notif.text" :show.sync="notif.show"></dig-notif>
  </div>
</template>

<script>
import Tab from '../digilib_web/vue/tab.vue'
import Form from '../digilib_web/vue/form.vue'
import Table from '../digilib_web/vue/table.vue'
import Notif from '../digilib_web/vue/notif.vue'
import { Http } from '../digilib_web/core/digitify.js'

export default {
  methods: {
    OnChangeTab: function(index) {
      if (index == 0) {
        this.GetUserList();
      }
    },
    GetUserList: function() {
      this.userList.isLoading = true;
      this.userList.data = [];
      Http.Request(
        'GET', 'my-reimbursements',
        {
          OnResponse:function(json) {
            this.userList.isLoading = false;
            this.userList.data = json;
          }.bind(this)
        }
      );
    },
    OnSubmitAdd: function(val) {
      this.add.isLoading = true;
      Http.Request(
        'POST', 'reimbursements',
        {
          data: val,
          OnResponse:function(json) {
            this.add.isLoading = false;
            if (json.success) {
              this.notif.text = json.msg;
              this.notif.show = true;
              this.$refs.formAdd.SetValues({});
              this.selectedUserTab = 0;
              this.GetUserList();
            } else {
              alert(json.msg);
            }
          }.bind(this)
        }
      );
    },
  },
  components: {
    'dig-tab': Tab,
    'dig-form': Form,
    'dig-table': Table,
    'dig-notif': Notif,
  },
  mounted() {
    this.GetUserList();
    Http.Request(
      'GET', 'cashflow_types/enum',
      {
        data: {key:'is_pengeluaran', operator:'<>', value: 0},
        OnResponse:function(json) {
          this.add.form[1].options = json;
        }.bind(this)
      }
    );
  },
  data() {
		return {
      selectedUserTab:0,
			userItems: [
        {title:'List Reimbursement', icon:'fa fa-database'},
        {title:'Create New', icon:'fa fa-plus'}
      ],
      userList: {
        isLoading: false,
        data: [],
        hidden: ['id', 'tipe', 'id_jenis_cashflow'],
      },
      add: {
        form: [
          {name:'tanggal', title:'Tanggal', inputType:'calendarpicker', required:true},
          {name:'id_jenis_cashflow', title:'Jenis', inputType:'select', options:[], required:true},
          {name:'deskripsi', title:'Deskripsi', inputType:'input', required:true},
          {name:'nominal', title:'Nominal', inputType:'input', type:'number', required:true},
        ],
        isLoading: false,
      },
      notif: {text:'', show:false}
		}
	},
}
</script>

<style scoped>
</style>
